module.exports = __webpack_public_path__ + "assets/89a03c91a4e093cd178ff12817ebd2a6.png";